"use client";

/**
 * β-8 v3 — 인증 가드 hook.
 *
 * 새로고침 시 zustand persist hydration 완료 전까지 redirect 보류.
 * (hydration 전엔 isLoggedIn=false 인데 실제 로그인 상태일 수 있음 → 잘못된 redirect 방지)
 *
 * 사용:
 *   const ready = useAuthGuard();
 *   if (!ready) return <LoadingSpinner />;
 */
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/store/auth";

export function useAuthGuard(redirectTo: string = "/login"): boolean {
  const router = useRouter();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;
    if (!isLoggedIn) router.replace(redirectTo);
  }, [hasHydrated, isLoggedIn, router, redirectTo]);

  return hasHydrated && isLoggedIn;
}
